import React from 'react';

import { Updating } from './Visuals';

const Loading : React.SFC<any> = (props) => {
    return (<div style={{ textAlign: 'center' }}>
        <div style={{ marginBottom: '0.5rem' }}>
            <Updating size={25}/>
        </div>
        {props.children}
    </div>)
}

export default Loading